export function isAppSelectedFactory(customGroupForm) {
  return (application) =>
    customGroupForm.appsWithEntryPoints.some((appWithEntryPoints) => appWithEntryPoints.application === application);
}
